import {
  CButton,
  CCard,
  CCardBody,
  CCardFooter,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CRow,
} from '@coreui/react'
import CIcon from "@coreui/icons-react";
import { t } from 'i18next'
import { useState } from 'react'
import { validateEmail } from '@webkit/functions/Validators'
import Input from '@webkit/components/Input.js'
import { cilLockLocked, cilUser, cilLowVision } from '@coreui/icons'
import AuthService from '@services/auth.service'
import Cookies from 'js-cookie'
import { DataLogin } from '@models/data-login.model'
import { useNavigate } from 'react-router-dom'
import { COOKIE_ENUM } from '@webkit/enums/cookie.enum'
import UserService from '@services/user.service'
import logoDark from "@assets/images/logo-hostyble-dark.png"
import { useSpinner } from '@webkit/components/typescript/SpinnerContext';
import { getToastStore } from '@utils/ToastStore';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import AppEnviroment from "app-enviroment";

const LoginForm = () => {
  const ctx = getToastStore();
  const [seeModal, setSeeModal] = useState(false)
  const [notFoundError, setNotFoundError] = useState("")
  const { showSpinner, hideSpinner } = useSpinner();
  const [emailRecoverError, setEmailRecoverError] = useState("")
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    email: ''
  });

  const navigate = useNavigate();

  const [formErrors, setFormErrors] = useState({
    username: '',
    password: '',
    email: ''
  });

  const buttonStyle = {
    backgroundColor: '#00BFA6',
    color: 'white',
    borderRadius: '25px',
    marginTop: '10px',
  };

  const [showPassword, setShowPassword] = useState(false);
  const togglePassword = () => setShowPassword((prev) => !prev);

  const getFieldValue = (fieldName) => {
    return formData[fieldName] ||
      document.querySelector(`input[name="${fieldName}"]`)?.value || '';
  };

  const validateForm = (val) => {
    const name = val?.target?.name;
    let errors = { ...formErrors };
    let isValid = true;

    const checkField = (fieldName) => {
      if (!getFieldValue(fieldName)) {
        errors[fieldName] = t('error.required', { field: fieldName });
        isValid = false;
      } else {
        errors[fieldName] = '';
      }
    };

    if (name) {
      checkField(name);
    } else {
      checkField('username');
      checkField('password');
    }

    setFormErrors(errors);
    return isValid;
  };

  const validateRecover = (val) => {
    const name = val?.target?.name;
    let errors = { ...formErrors };
    let isValid = true;

    isValid = validateEmail(formData[name], errors);

    setFormErrors(errors);
    return isValid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const username = document.querySelector('input[name="username"]')?.value;
    const password = document.querySelector('input[name="password"]')?.value;

    if (username) setFormData(prev => ({ ...prev, username }));
    if (password) setFormData(prev => ({ ...prev, password }));

    if (!username || !password) {
      setFormErrors({
        ...formErrors,
        username: !username ? t('error.required', { field: 'username' }) : '',
        password: !password ? t("error.required", { field: 'password' }) : '',
      });
      return;
    }

    try {
      showSpinner()
      const response = await AuthService.handleLogin(
        new DataLogin(username.trim(), password.trim())
      );

      if (response?.token) {
        Cookies.set(COOKIE_ENUM.HST_USER_TOKEN, response.token, {
          expires: 365 * 20,
          path: '/',
          secure: true,
          sameSite: 'lax',
        });
        await recoverProfileData(response.token);
        const msg = response?.data?.message || t("success.welcome")
        ctx.setToastMsg(msg);
        ctx.setSeeToast(true);
        ctx.setErrorToast(false)
        navigate("/");
      }
    } catch (error) {
      setNotFoundError(t("error.login_failed"))
    } finally {
      hideSpinner()
    }
  };

  const handleRecoverPassword = async (event) => {
    event.preventDefault();
    try {
      showSpinner()
      const response = await AuthService.forgotPassword(formData.email)
      const msg = response?.data?.message || t("success.reset_email_sent")
      ctx.setToastMsg(msg);
      ctx.setErrorToast(false)
      ctx.setSeeToast(true);
    } catch (error) {
      setEmailRecoverError(t("error.invalid_email"))
    } finally {
      hideSpinner()
    }
  }

  const recoverProfileData = async (token) => {
    try {
      if (token) {
        const user = await UserService.findUserByToken();
        Cookies.set(COOKIE_ENUM.HST_USER_PROFILE_DATA, JSON.stringify(user), {
          expires: 365 * 20,
          path: '/',
          secure: true,
          sameSite: 'lax',
        });
      }
    } catch (error) {
      if (error?.message) {
        console.error("Errore nel recupero dei dati dell'utente", error);
      }
    }
  }

  return (
    <div className='min-vh-100 d-flex flex-row align-items-center smart-login-container img-background'>
      <CContainer>
        <CRow className='justify-content-center'>
          <CCol md={5}>
            <CCardGroup>
              <CCard
                className='p-4 text-center smart-login-container-card shadow-lg hst-card'
                style={{ borderRadius: '25px' }}>
                <CCardBody>
                  <CForm onSubmit={handleSubmit}>
                    <img src={logoDark} style={{ width: "65%", marginBottom: "20px" }} />
                    <p className='text-body-secondary' style={{ fontSize: "90%" }}>{t('label.login_into_account')}</p>
                    <Input
                      className='col-12'
                      name='username'
                      label={t('label.username')}
                      required={true}
                      icon={cilUser}
                      formData={formData}
                      formErrors={formErrors}
                      validateForm={validateForm}
                      handleChange={handleChange}
                      onInput={handleInput}
                      onBlur={validateForm}
                    />
                    <div className="position-relative">
                      <Input
                        className="col-12"
                        name="password"
                        label="label.password"
                        required
                        type={showPassword ? "text" : "password"}
                        icon={cilLockLocked}
                        formData={formData}
                        formErrors={formErrors}
                        validateForm={validateForm}
                        handleChange={handleChange}
                        onInput={handleInput}
                        onBlur={validateForm}
                      />
                      <span
                        style={{
                          position: "absolute",
                          top: "40px",
                          right: "10px",
                          cursor: "pointer",
                        }}
                        onClick={togglePassword}
                        title={showPassword ? "Hide password" : "Show password"}
                      >
                        <CIcon icon={cilLowVision} />
                      </span>
                      {formErrors.password && formErrors.password !== '' && (
                        <div className="text-danger mt-1">
                          {formErrors.password}
                        </div>
                      )}
                    </div>

                    <div className='w-100 text-end'>
                      <span role="button" className='text-decoration-underline text-primary' onClick={() => setSeeModal(!seeModal)}>
                        {t("label.forgot_password")}
                      </span>
                    </div>
                    <CRow>
                      <CCol xs={12} className='d-flex justify-content-center'>
                        <CButton
                          style={buttonStyle}
                          type='submit'
                          className='px-4 col-12 text-uppercase'
                        >
                          {t('label.login')}
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
                <CCardFooter className='bg-transparent'>
                  <p className='text-body-secondary'>
                    {t('label.have_no_account')}{" "}
                    <a href="/signup"> {t('button.signup')} </a>
                  </p>
                </CCardFooter>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
      {seeModal ?
        <div className='min-vh-100 d-flex flex-row align-items-center smart-login-container fullscreen-overlay'>
          <CCard
            className='p-4 text-center smart-login-container-card shadow-lg hst-card'
            style={{ borderRadius: '25px' }}>
            <div className='d-flex flex-row align-items-center gap-3 mb-3'>
              <span>{t("text.recover_email")}</span>
              <i className="close-modal fa-solid fa-xmark fs-2" onClick={() => setSeeModal(false)}></i>
            </div>
            <CForm onSubmit={handleRecoverPassword}>
              <Input
                className="col-12"
                name="email"
                placeholder={"label.email_placeholder"}
                formData={formData}
                formErrors={formErrors}
                validateForm={validateRecover}
                handleChange={handleChange}
              />
              <CRow>
                <CCol xs={12} className='d-flex justify-content-center'>
                  <CButton
                    style={buttonStyle}
                    type='submit'
                    className='px-4 col-12 text-uppercase'>
                    {t('button.submit')}
                  </CButton>
                </CCol>
              </CRow>
            </CForm>
          </CCard>
        </div> : null}
    </div>
  )
}
const SignUp = () => {
    const siteKey= AppEnviroment.getRecaptchaSite();
    return (
      <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
        <LoginForm />
      </GoogleReCaptchaProvider>
    );
};
export default SignUp